import React from "react";
import WalletConnect from "./WalletConnect";

const WalletPage: React.FC = () => {
  return (
    <div>
      <WalletConnect />
    </div>
  );
};

export default WalletPage;
